import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';

const ResultModal = ({ isOpen, title, entry, onClose, refresh }) => {

  const [display, setDisplay] = React.useState(false);

  const currentDomain = () => {
    //if location origin starts with localhost, return localhost:3001
    if (location.origin.startsWith('http://localhost')) {
      return 'http://localhost:3001';
    } else {
      return location.origin;
    }
  }


  const handleInput = (e) => {
    if (e.target.value.length > 2) {
      e.target.value = e.target.value.slice(0, 2); // Only allow 2 characters
    }
    setDisplay(e.target.value)
  };

  const saveOverride = () => {
    if (entry.ballots && display && display >= 0 && display <= 25) {
      console.log('Saving override:', display);
      //Loading
      fetch(`${currentDomain(location)}/api/ballot/override/${display}/${entry.car_id}/update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if (response.ok) {
          onClose()
          //Loading
        } else {
          throw new Error();
        }
      }).catch((error) => {
        toast.error('Error saving override:', error);
        onClose();
      });
    }
    else{
      onClose()
    }
  }

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          {/* Background Overlay */}
          <div className="fixed inset-0 bg-black opacity-50"></div>

          {/* Modal Content */}
          <div className="bg-white p-6 rounded-lg shadow-lg z-10 max-w-md w-full">
            {/* Modal Header */}


            {/* Modal Body: Display the entry details */}
            {entry ? (
              <div className="mb-4">
                <p><strong>Year:</strong> {entry.year}</p>
                <p><strong>Make:</strong> {entry.make}</p>
                <p><strong>Model:</strong> {entry.model}</p>
                <p><strong>Class:</strong> {entry.class_name}</p>
                <p><strong>Owner:</strong> {entry.owner_first_name} {entry.owner_last_name}</p>
                <p><strong>Paid:</strong> {entry.ispaid ? 'Yes' : 'No'}</p>
                <p><strong>Phone:</strong> {entry.owner_phone}</p>
                <p><strong>Car UUID:</strong> {entry.car_id}</p>
                <p><strong>Owner UUID:</strong> {entry.owner_id}</p>
                <p><strong>Class UUID:</strong> {entry.class_id}</p>

              </div>
            ) : (
              <p>No entry selected.</p>
            )}

            {/* Modal Footer */}
            <div className="flex justify-between w-full">
              <div className="flex-1 flex justify-center">
                {entry.ballots ? (
                  <input
                    type="number"
                    max={25}
                    placeholder='0'
                    onInput={handleInput}
                    min={0}
                    className={`w-16 h-12 p-1 ps-4 text-2xl border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 `}
                  />) : null}
              </div>
              <div className="flex-1 flex justify-center">
                <button
                  onClick={saveOverride}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ResultModal;
